import { render, staticRenderFns } from "./RecipesListView.vue?vue&type=template&id=cc94d572&scoped=true"
import script from "./RecipesListView.vue?vue&type=script&lang=js"
export * from "./RecipesListView.vue?vue&type=script&lang=js"
import style0 from "./RecipesListView.vue?vue&type=style&index=0&id=cc94d572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc94d572",
  null
  
)

export default component.exports